import { EcouponErrorMessageConfig } from '@msc-b2c/interfaces/types';

export const GENERIC_ECOUPON_PAYMENT_ERROR_CODE = '__generic_ecoupon_payment_error__';

export const normalizeEcouponErrorCode = (code?: string): string =>
  code?.trim().toLowerCase() ?? '';

export const getEcouponErrorConfigList = (
  ecouponErrorMessageConfigList?:
    | EcouponErrorMessageConfig[]
    | Record<string, EcouponErrorMessageConfig>,
  ecouponErrorMessageConfigListResources?: EcouponErrorMessageConfig[]
): EcouponErrorMessageConfig[] => {
  const sourceConfigList =
    ecouponErrorMessageConfigListResources || ecouponErrorMessageConfigList || [];
  return Array.isArray(sourceConfigList) ? sourceConfigList : Object.values(sourceConfigList);
};

/** True when the API code exists in checkout AEM ecoupon error map. */
export const isConfiguredEcouponErrorCode = (
  code: string | undefined,
  ecouponErrorMessageConfigList?:
    | EcouponErrorMessageConfig[]
    | Record<string, EcouponErrorMessageConfig>,
  ecouponErrorMessageConfigListResources?: EcouponErrorMessageConfig[]
): boolean => {
  const normalizedCode = normalizeEcouponErrorCode(code);
  if (!normalizedCode) return false;

  return getEcouponErrorConfigList(
    ecouponErrorMessageConfigList,
    ecouponErrorMessageConfigListResources
  ).some((item) => normalizeEcouponErrorCode(item?.errorCodeConfiguration) === normalizedCode);
};

export const isHandledPaymentCouponErrorCode = (
  code: string | undefined,
  ecouponErrorMessageConfigList?:
    | EcouponErrorMessageConfig[]
    | Record<string, EcouponErrorMessageConfig>,
  ecouponErrorMessageConfigListResources?: EcouponErrorMessageConfig[]
): boolean =>
  code === GENERIC_ECOUPON_PAYMENT_ERROR_CODE ||
  isConfiguredEcouponErrorCode(
    code,
    ecouponErrorMessageConfigList,
    ecouponErrorMessageConfigListResources
  );

export const getEcouponErrorMessageByCode = (
  apiCode: string | undefined,
  ecouponErrorMessageConfigList?:
    | EcouponErrorMessageConfig[]
    | Record<string, EcouponErrorMessageConfig>,
  ecouponErrorMessageConfigListResources?: EcouponErrorMessageConfig[],
  genericEcouponErrorMessage?: string
): string => {
  if (!apiCode || apiCode === GENERIC_ECOUPON_PAYMENT_ERROR_CODE) {
    return genericEcouponErrorMessage || '';
  }

  const normalizedApiCode = normalizeEcouponErrorCode(apiCode);
  const matchedConfig = getEcouponErrorConfigList(
    ecouponErrorMessageConfigList,
    ecouponErrorMessageConfigListResources
  ).find((item) => normalizeEcouponErrorCode(item?.errorCodeConfiguration) === normalizedApiCode);

  return matchedConfig?.errorMessageConfiguration || genericEcouponErrorMessage || '';
};

export const extractEcouponIssueCodeFromError = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }
  const maybeError = error as {
    issue_code?: string;
    code?: string;
    causes?: string;
    response?: { data?: { issue_code?: string; code?: string } };
  };

  return (
    maybeError.issue_code ??
    maybeError.code ??
    maybeError.response?.data?.issue_code ??
    maybeError.response?.data?.code ??
    maybeError.causes
  );
};
